import Vue from 'vue'
const moment = require('moment')

Vue.filter('dateFormat', function (value, type) {
    if (!value) return ''
    let baseDate = parseInt(value.replace('/Date(', ''))
    let date = moment(baseDate);
    if(type == 'date')
        return date.format('DD.MM.YYYY')
    else
        return date.format('DD.MM.YYYY / HH:mm:ss')
})
